module.exports = __webpack_public_path__ + "media/images/categories/color/support-9d24c4d53f771271169fb3c4c338639d.png";